import React from "react";
import { Checkbox as AntCheckbox, Form } from "antd";

import * as values from "values";
import { OfferTypeNames } from "values";
import { NumberField } from "Form/InputFields";
import Checkbox, { renderCheckboxes } from "Form/Checkbox";
import {
    Floors,
    MapAndLocation,
    Ownership,
    Prices,
    PropertiesCondition,
    TypesOfBuilding,
} from "Components/Filters/FilterComponents";
import FilterComponent from "Components/Filters/Filter";
import { FilterTypes, FlatOffer, FlatsFilter } from "Types";

const FlatsFilterComponent = (): JSX.Element => {
    return (
        <FilterComponent<FlatOffer, FlatsFilter> type={FilterTypes.flats} label={OfferTypeNames.flats}>
            {(formik, filter): JSX.Element => (
                <>
                    <Form.Item label={"Dispozice"}>
                        <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                            {renderCheckboxes(values.availableDispositions, "dispositions", formik)}
                        </AntCheckbox.Group>
                    </Form.Item>
                    <PropertiesCondition formik={formik} />
                    <MapAndLocation formik={formik} filter={filter} />
                    <Prices />
                    <Ownership formik={formik} />
                    <TypesOfBuilding formik={formik} />
                    <Floors />

                    <Form.Item label={"Užitná plocha"}>
                        <div className={"rmxo-input-inline"}>
                            <div>
                                <NumberField name={"sizeTotalFrom"} placeholder={"Užitná plocha od"} />
                            </div>
                            <div>
                                <NumberField name={"sizeTotalTo"} placeholder={"Užitná plocha do"} />
                            </div>
                        </div>
                    </Form.Item>

                    <Form.Item label={"Další"}>
                        <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                            <Checkbox setValue={formik.setFieldValue} name={"balcony"} value={true} label={"Balkón"} />
                            <Checkbox setValue={formik.setFieldValue} name={"terrace"} value={true} label={"Terasa"} />
                            <Checkbox
                                setValue={formik.setFieldValue}
                                name={"parking"}
                                value={true}
                                label={"Parkování"}
                            />
                            <Checkbox setValue={formik.setFieldValue} name={"lift"} value={true} label={"Výtah"} />
                            <Checkbox setValue={formik.setFieldValue} name={"lodzie"} value={true} label={"Lodžie"} />
                            <Checkbox setValue={formik.setFieldValue} name={"garage"} value={true} label={"Garáž"} />
                            <Checkbox setValue={formik.setFieldValue} name={"cellar"} value={true} label={"Sklep"} />
                        </AntCheckbox.Group>
                    </Form.Item>
                </>
            )}
        </FilterComponent>
    );
};

export default FlatsFilterComponent;
